<template>
	<div :class="classes">
		<slot />
	</div>
</template>

<script>
export default {
	props: {
		to: {
			type: String,
			required: true
		},
		where: {
			type: String,
			default: 'after'
		},
		disabled: Boolean
	},
	data() {
		return {
			nodes: [],
			parent: null
		};
	},
	watch: {
		to: 'maybeMove',
		where: 'maybeMove',
		disabled(value) {
			if (value) {
				this.disable();
			} else {
				this.move();
			}
		}
	},
	mounted() {
		// Store a reference to the nodes
		this.nodes = Array.from(this.$el.childNodes);
		if (!this.disabled) {
			this.move();
		}
	},
	beforeDestroy() {
		// Move back to original position
		this.disable();
	},
	computed: {
		classes() {
			return this.disabled ? ['teleporter'] : ['teleporter', 'hidden'];
		}
	},
	methods: {
		maybeMove() {
			if (!this.disabled) {
				this.move();
			}
		},
		move() {
			const parent = document.querySelector(this.to);
			if (!parent) {
				console.error(`Target element "${this.to}" not found.`);
				return;
			}

			this.parent = parent;
			const fragment = this.getFragment();

			if (this.where === 'before') {
				this.parent.prepend(fragment);
			} else {
				this.parent.appendChild(fragment);
			}
		},
		disable() {
			if (this.parent) {
				const fragment = this.getFragment();
				this.$el.appendChild(fragment);
				this.parent = null;
			}
		},
		getFragment() {
			const fragment = document.createDocumentFragment();
			this.nodes.forEach(node => fragment.appendChild(node));
			return fragment;
		}
	}
};
</script>

<style scoped lang="less">
.hidden {
	visibility: hidden;
	display: none;
}
</style>
